import { Mark, Class } from '@/plugins/api'
import alert from '@/plugins/alert'
import utils from '../../plugins/utils'
import { orderBy, keyBy, max } from 'lodash-es'

const setMaxColumnForSemester = (semesters = [], sortedFactors = []) => {
  return semesters.map(s => {
    return {
      ...s,
      maxColumn: sortedFactors
        .filter(x => x.semesterType === s.type)
        .map(x => x.maxColumn)
        .reduce((a, c) => a + c, 0)
    }
  })
}

const getFactorsByFilter = (rawFactors = [], filteredType = '') => {
  if (filteredType === 'year') {
    const semester1Factors = rawFactors.filter(x => x.semesterType === 'semester-1').sort((a, b) => a.index - b.index)
    const semester2Factors = rawFactors.filter(x => x.semesterType === 'semester-2').sort((a, b) => a.index - b.index)
    return [...semester1Factors, ...semester2Factors]
  }
  return rawFactors.filter(x => x.semesterType === filteredType).sort((a, b) => a.index - b.index)
}

export default {
  namespaced: true,
  state: {
    marks: [],
    students: [],
    factors: [],
    subject: {},
    studentMarks: [],
    semesters: []
  },
  actions: {
    async fetchClassMarks({ commit }, options) {
      try {
        const classData = options.class
        const currentClass = await Class.fetchOne(classData.id)
        const students = utils.sortListByName(currentClass.students.filter(s => s.status === 'active'))
        const subjectFactors = options.subject.factors
        const filterSemesterType = options.semester.type

        let factors = getFactorsByFilter(subjectFactors, filterSemesterType)

        const markFetchParams = {
          class: classData.id,
          subject: options.subject.id,
          _limit: -1
        }
        if (filterSemesterType !== 'year') {
          markFetchParams.semester = options.semester.id
        }
        const marks = await Mark.fetch(markFetchParams)

        // lấy số cột điểm tối đa trên 1 factor
        factors = keyBy(factors, 'id')
        Object.values(factors).reduce((_, factor) => {
          const factorMarks = students.reduce((acc, student) => {
            const markNo = marks.filter(m => m.factor.id === factor.id && m.student.id === student.id).length
            return [...acc, markNo]
          }, [])
          factors[factor.id] = {
            ...factors[factor.id],
            maxColumn: max(factorMarks) > factor.quantity ? max(factorMarks) : factor.quantity
          }
        }, [])

        const sortedFactors = Object.values(factors)

        // tạo điểm theo từng Học viên
        const studentMarks = students.reduce((acc, student) => {
          const SMs = sortedFactors.reduce((acc, factor) => {
            const markObject = marks.filter(m => m.factor.id === factor.id && m.student.id === student.id) // tìm điểm theo factor và student tương ứng
            let markByFactor = Array.from(Array(factor.maxColumn).keys()).map(index => markObject[index] || {})
            markByFactor = orderBy(markByFactor, ['date'], ['asc'])

            return [...acc, ...markByFactor]
          }, []) // build factor schema

          return [...acc, { student, marks: SMs }]
        }, [])

        const rawSemesters = filterSemesterType === 'year' ? options.semester.semesters : [options.semester]
        const semesters = setMaxColumnForSemester(rawSemesters, sortedFactors)

        commit('changeState', {
          studentMarks,
          factors: sortedFactors,
          semesters,
          subject: options.subject
        })
      } catch (error) {
        alert.error(error)
      }
    }
  },
  mutations: {}
}
